import { useQuery } from '@tanstack/react-query';

import { featureFlagsApi } from '@/api/feature-flags';
import { useAuth } from '@/context/AuthContext';

export const FEATURE_FLAGS_QUERY_KEY = ['feature-flags'] as const;

export function useFeatureFlags(options: { enabled?: boolean } = {}) {
    const { status } = useAuth();
    const enabled = options.enabled ?? status === 'active';
    const query = useQuery({
        queryKey: FEATURE_FLAGS_QUERY_KEY,
        queryFn: featureFlagsApi.getFeatureFlags,
        enabled,
        staleTime: 30_000,
    });

    return {
        flags: query.data ?? {},
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isError: query.isError,
        error: query.error,
        refetch: query.refetch,
    };
}
